import { createMemo } from "solid-js";
import { type AdminCapability, roleCan } from "@listto/shared";
import { useSession } from "@/lib/auth";

/**
 * Reactive view of the current admin's role + capability checks. Mirrors the
 * backend capability map (`@listto/shared` `capabilities`) so the back-office UI
 * never offers an action that would 403. The backend stays the source of truth.
 */
export function useAdminCapabilities() {
  const session = useSession();
  const role = createMemo(() => session.data?.user.role);
  const can = (capability: AdminCapability) => roleCan(role(), capability);
  return { role, can };
}
